import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../client';

export function useEmailVerification() {
  const resendMutation = useMutation({
    mutationFn: async () => {
      const response = await apiClient.post<{ message: string }>(
        '/api/v1/email/verification-notification'
      );
      return response.data;
    },
  });

  return {
    resendEmail: resendMutation.mutate,
    isResending: resendMutation.isPending,
    resendSuccess: resendMutation.isSuccess,
    resendError: resendMutation.error,
  };
}
